import React from 'react'
import { NewBrandingHoc } from '../../utils/NewBrandingHoc'
import { RichText } from '../RichText'
import { IProps } from './index'
import styles from './styles-legacy.scss'
import { EditorialInfo as EditorialInfoDefault } from './element'

function EditorialInfoLegacy({ info }: IProps) {
  return (
    <div className="editorial-info">
      <div className="editorial-info__attributes">
        <RichText document={info} />
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}

export const EditorialInfo = NewBrandingHoc(EditorialInfoLegacy, EditorialInfoDefault)
